module.exports = __webpack_public_path__ + "static/img/cont44_06.9ac8b88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_06.jpg
// module id = 98J7
// module chunks = 0